import { CdkStep } from '@angular/cdk/stepper';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
} from '@angular/core';

import { AtxStepLabel } from '../../directives';

@Component({
  selector: 'atx-step',
  templateUrl: './step.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: CdkStep, useExisting: AtxStep }],
  standalone: false,
})
export class AtxStep extends CdkStep {
  @ContentChild(AtxStepLabel) public stepLabel: AtxStepLabel;
}
